module.exports = __webpack_public_path__ + "img/p5.019b4e03.png";